import { z } from "zod";
import { IPortalBox } from "@ecp-pageTypes";
import { GenericBoxData } from "@ecp-redux/dto/page/union.types";
import {
  IBoxComplaintFormMessagesScheme,
  IBoxComplaintFormSettingsScheme,
} from "./BoxComplaintForm.scheme";

export type IBoxComplaintForm = GenericBoxData<
  { component: "NEW_CONTACT_FORM" },
  Record<string, never>,
  Record<string, never>,
  IBoxComplaintFormMessages,
  IBoxComplaintFormSettings
>;

export type TBoxComplaintFormProps = IPortalBox<IBoxComplaintForm>;

export type IBoxComplaintFormMessages = z.infer<
  typeof IBoxComplaintFormMessagesScheme
>;

export type IBoxComplaintFormSettings = z.infer<
  typeof IBoxComplaintFormSettingsScheme
>;

export enum BoxComplaintFormFields {
  FULL_NAME = "fullName",
  CONTACT = "contact",
  ORDER_NUMBER = "orderNumber",
  PURCHASE_DATE = "purchaseDate",
  PRODUCT = "product",
  ISSUE_DESCRIPTION = "issueDescription",
  REQUESTED_SOLUTION = "requestedSolution",
}
